//////// Utils /////////
////////////////////////

function S(t, e) {
  if (null === e) return t;
  if ("master" === e) return j(t);
  var n = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  if (n) {
    var r = t.split(n[0]),
      i = n[0];
    return j("".concat(r[0], "_").concat(e).concat(i));
  }
  return null;
}
function j(t) {
  return t.replace(/http(s)?:/, "");
}
console.log(
  "url",
  ""
    .concat(
      `${Shopify.locale == "de" ? "" : "/en"}/cart`,
      "?view=json&timestamp="
    )
    .concat(Date.now())
);
//////// Components /////////
/////////////////////////////

Vue.component("cart-summary", {
  props: ["savings", "total", "translations"],
  template: `
    <div class="cart-form__summary">
      <div class="cart-shipping"><span v-if="translations.shipping !== null">{{translations.shipping}}</span><span v-if="translations.calculateship !== null">{{translations.calculateship}}</span></div>
      <div class="cart-savings" v-if="savings != 0.00" :data-saving="savings"><span v-if="translations.savings !== null">{{translations.savings}}</span><span>{{w(parseInt(savings),window.theme.currency.moneyWithCurrencyFormat)}}</span></div>
      <div class="cart-total"><span v-if="translations.total !== null">{{translations.total}}</span><span>{{w(parseFloat(total),window.theme.currency.moneyWithCurrencyFormat)}}</span></div>
      <button class="btn btn-primary rf-submit-to-cart" @click.prevent="$emit('go-to-cart')" name="cart" v-if="translations.button !== null">{{translations.button}}</button>
    </div>`,
});

Vue.component("cart-item", {
  props: [
    "id",
    "title",
    "url",
    "stock",
    "quantity",
    "image",
    "price",
    "attributes",
  ],
  template: `<li class="cart-item">
        <div class="cart-item__image u-aspect-ratio" style="--aspect-ratio: 1;">
		<a :href="url">
		<img class="lazy"
			 v-if="image.src"
			 :alt="image.alt" 
			 data-sizes="auto" 
			 data-widths="[200,300,400]" 
			:data-src="S(image.src, '{width}x')">
		</a>
		</div>
        <div class="cart-item__details">
			<span class="cart-item__title" v-if="title" data-id>{{title}}</span>
           <template v-for="attribute in attributes">
             <span class="cart-item__attribute">{{attribute.name}}: </span><span class="cart-item__attribute">{{attribute.value}}</span><br/>
           </template>
		  <template v-if="price.unit.regular != 0">
          <div class="cart-item__quantity">
            <select name="update" aria-label="Wähle deine Menge aus:" @change="$emit('update-item',id,$event.target.value)">
				<option v-for="n in stock" :value="n" :selected="n == quantity">{{n}}</option>
            </select>
            <i class="icon icon-dropdown"></i>
          </div>
		  </template>
        </div>
        <div class="cart-item__price">
			<span class="price price--striked" v-if="price.unit.compareAt">{{w(parseFloat(price.unit.compareAt),window.theme.currency.moneyWithCurrencyFormat)}}</span>
			<span class="price" v-if="price.unit.regular">{{w(parseFloat(price.unit.regular),window.theme.currency.moneyWithCurrencyFormat)}}</span></div>
        	<button class="cart-item__remove" name="remove" @click.prevent="$emit('update-item',id,0)" aria-label="Shavasana Set aus dem Warenkorb entfernen"><i class="icon icon-close"></i></button>
      </li>`,
});

//////// Cart Page /////////
////////////////////////////

var cartPageApp = new Vue({
  el: "#cart-js",
  data: {
    cartURL: ""
      .concat(
        `${Shopify.locale == "de" ? "" : "/en"}/cart`,
        "?view=json&timestamp="
      )
      .concat(Date.now()),
    item_count: 0,
    translations: null,
    summary: null,
    items: null,
    included: null,
    show_included: false,
  },
  methods: {
    updateQuantity: function (id, quantity) {
      jQuery.post(
        "/cart/update.js",
        {
          updates: {
            [id]: quantity,
          },
        },
        (data) => {
          this.updateCart();
        }
      );
    },
    updateCart: function () {
      fetch(this.cartURL)
        .then((res) => res.json())
        .then((data) => {
          console.log("Complete cart page>>>", data);
          this.items = data.items;
          this.item_count = data.itemCount;
          this.translations = data.translations;
          this.summary = data.summary;
          this.included = data.included;
          this.checkIncluded();
        });
    },
    updateItem: function (id, q) {
      jQuery
        .post("/cart/update.js", {
          updates: { [id]: q },
        })
        .then((res) => {
          this.updateCart();
          minicart.getCart();
          this.checkIncluded();
        });
    },
    formatPrice: function (price) {
      return w(
        parseFloat(price),
        window.theme.currency.moneyWithCurrencyFormat
      );
    },
    checkIncluded: function () {
      console.log("Items in cart", this.items);
      let text = this.included.text;
      let is_exist = false;
      this.items.forEach((item) => {
        if (item.title.toLowerCase().includes(text.toLowerCase())) {
          is_exist = true;
        }
      });
      if (is_exist) {
        this.show_included = true;
      } else {
        this.show_included = false;
      }
      console.log(
        this.show_included,
        this.included.enabled,
        this.included.text,
        this.included.note
      );
    },
  },
  created() {
    this.updateCart();
  },
});

//////// Mini Cart /////////
////////////////////////////

var minicart = new Vue({
  el: "#cart-bag",
  data: {
    cartURL: ""
      .concat(
        `${Shopify.locale == "de" ? "" : "/en"}/cart`,
        "?view=json&timestamp="
      )
      .concat(Date.now()),
    items: null,
    item_count: 0,
    translations: null,
    summary: null,
    discounted: null,
    discountedInCart: false,
    cart_original_total: 0,
    range_slider_background: null,
    included: null,
    show_included: false,
  },
  watch: {
    cart_original_total: function (newVal, oldVal) {
      if (this.discounted.product_id.length == 0) {
        return;
      }
      let max = parseInt(this.discounted.price_range);
      let min = 0;
      let value = parseInt(newVal);
      if (value === min) {
        return;
      }
      let percentage = ((value - min) / (max - min)) * 100;

      console.log("Percentage>>>", percentage);
      this.range_slider_background =
        "background: linear-gradient(to right, #ffaa8f, #ffaa8f " +
        percentage +
        "%, #d3edff " +
        (percentage + 2) +
        "%, #dee1e2 100%)";
    },
  },
  methods: {
    getCart: function () {
      console.log("Cart URL", this.cartURL);
      fetch(this.cartURL)
        .then((res) => res.json())
        .then((data) => {
          console.log("Complete>>>", data);
          this.items = data.items;
          this.item_count = data.itemCount;
          this.translations = data.translations;
          this.summary = data.summary;
          this.discounted = data.discounted;
          this.checkDiscountedInCart();
          this.checkDiscounted();
          this.included = data.included;
          this.checkIncluded();

          for (
            var e = document.querySelectorAll('a[href="/cart"]'), n = 0;
            n < e.length;
            n += 1
          )
            e[n].setAttribute("data-item-count", this.item_count);
          if (this.summary.total == 0) {
            this.updateSliderBackground(0);
          }
        });
    },
    goToCart: function () {
      window.location.href = Shopify.locale == "en" ? "/en/cart" : "/cart";
    },
    updateCart: function () {
      fetch(this.cartURL)
        .then((res) => res.json())
        .then((data) => {
          console.log("Updated Cart>>>", data);
          this.items = data.items;
          this.item_count = data.itemCount;
          this.summary = data.summary;
          this.discounted = data.discounted;
          this.checkDiscountedInCart();
          this.checkIncluded();

          cartPageApp.updateCart();
          for (
            var e = document.querySelectorAll('a[href="/cart"]'), n = 0;
            n < e.length;
            n += 1
          )
            e[n].setAttribute("data-item-count", this.item_count);
          if (this.summary.total == 0) {
            this.updateSliderBackground(0);
          }
        });
    },
    toggleCart: function () {
      document.querySelector(".overlay").classList.toggle("active");
      document.getElementById("cart-bag").classList.toggle("-active");
      console.log("Cart Toggle Now");
      document.getElementById("cart-bag").classList.contains("-active")
        ? document
            .querySelector(".overlay")
            .addEventListener("click", this.toggleCart.bind(this))
        : document
            .querySelector(".overlay")
            .removeEventListener("click", this.toggleCart.bind(this));
    },
    updateItem: function (id, q) {
      jQuery
        .post("/cart/update.js", {
          updates: { [id]: q },
        })
        .then((res) => {
          this.getCart();
        });
    },
    itemAdded: function () {
      this.getCart();
      this.toggleCart();
    },
    updateSliderBackground: function (percentage) {
      this.range_slider_background =
        "background: linear-gradient(to right, #ffaa8f, #ffaa8f " +
        percentage +
        "%, #d3edff " +
        (percentage + 2) +
        "%, #dee1e2 100%)";
    },
    checkDiscountedInCart: function () {
      if (this.discounted.product_id.length == 0) {
        return;
      }
      this.items.forEach((item) => {
        console.log(item.id, this.discounted.product_id);
        if (item.id == this.discounted.product_id) {
          this.discountedInCart = true;
        }
      });
    },
    checkDiscounted: function () {
      console.log("Running...>>>");
      if (
        this.discounted.product_id.length == 0 ||
        this.discounted.price_range.length == 0
      ) {
        this.cart_original_total = this.summary.total;
        return;
      }
      let range = parseInt(this.discounted.price_range);
      let totalPrice = this.summary.total;

      console.log(
        "PriceRange>>>",
        range,
        "TotalPrice",
        totalPrice,
        "InCart>>",
        this.discountedInCart
      );
      if (totalPrice >= range) {
        if (!this.discountedInCart) {
          console.log("Added");
          jQuery
            .post("/cart/add.js", {
              items: [
                {
                  quantity: 1,
                  id: this.discounted.product_id,
                },
              ],
            })
            .then((res) => {
              this.discountedInCart = true;
              this.updateCart();
            });
        }
      } else if (totalPrice < range) {
        if (this.discountedInCart) {
          console.log("Removed");
          jQuery
            .post("/cart/update.js", {
              updates: { [this.discounted.product_id]: 0 },
            })
            .then((res) => {
              this.discountedInCart = false;
              this.updateCart();
            });
        }
      }
      this.cart_original_total = totalPrice;
    },
    checkIncluded: function () {
      console.log("Items in cart", this.items);
      let text = this.included.text;
      let is_exist = false;
      this.items.forEach((item) => {
        if (item.title.toLowerCase().includes(text.toLowerCase())) {
          is_exist = true;
        }
      });
      if (is_exist) {
        this.show_included = true;
      } else {
        this.show_included = false;
      }
    },
    addItem: function () {
      this.getCart();
      this.toggleCart();
    },
  },
  created() {
    this.getCart();
    for (
      var e = document.querySelectorAll('a[href="/cart"]'), n = 0;
      n < e.length;
      n += 1
    )
      e[n].addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleCart();
      });
    document.addEventListener("miniCart:itemAdded", this.addItem.bind(this));
  },
});

//Range slider
var rangeSlider = document.getElementById("rs-range-line");
if (rangeSlider != null) {
  const min = rangeSlider.min;
  const max = rangeSlider.max;
  const value = rangeSlider.value;
  rangeSlider.style.background = `linear-gradient(to right, red 0%, red ${
    ((value - min) / (max - min)) * 100
  }%, #DEE2E6 ${((value - min) / (max - min)) * 100}%, #DEE2E6 100%)`;
  rangeSlider.addEventListener("input", showSliderValue, false);
  function showSliderValue() {
    this.style.background = `linear-gradient(to right, red 0%, red ${
      ((this.value - this.min) / (this.max - this.min)) * 100
    }%, #DEE2E6 ${
      ((this.value - this.min) / (this.max - this.min)) * 100
    }%, #DEE2E6 100%)`;
  }

  let currentValue = 0;
  rangeSlider.onclick = function (e) {
    currentValue = 1 - currentValue;
    e.target.value = currentValue;
    return false;
  };
}

//Product Card Add to cart method
$(document).on("click", ".product-card-add-to-cart--js", function (e) {
  e.preventDefault();
  let id = $(this).data("id");
  let elem = $(this).parents(".product-form").find(".product-select-variants");
  if ($(elem).val()) {
    console.log("Value is>>", $(elem).val());
    id = $(elem).val();
  }
  let quantity = 1;
  let quant = $(this).parents(".product-form").find("input[name='quantity']");
  if (quant) {
    quantity = quant.val();
  }
  let formData = {
    items: [
      {
        id,
        quantity,
      },
    ],
  };
  console.log("Item to be added>>", JSON.stringify(formData));
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log(data);
      minicart.itemAdded();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

$(document).on("submit", ".product-form", function (e) {
  e.preventDefault();
  // jQuery.post("/cart/add.js", $(this).serialize()).then((res) => {
  //   minicart.itemAdded();
  // });
  const formData = new FormData(this);
  console.log("formdata...", [...formData]);
});
